import { rgba } from 'polished';
import { useSystemTheme } from '@/ui/hooks/useSystemTheme';
import styles from './ECGBackground.module.css';

interface ECGBackgroundProps {
  width: number;
  height: number;
  pointSize: number;
  strokeStyle: string;
}

export const ECGBackground = ({
  width,
  height,
  pointSize,
  strokeStyle,
}: ECGBackgroundProps) => {
  const theme = useSystemTheme();
  const heightMinusOne = height - 1;
  const backgroundGuideAlpha = 0.1;
  const horizontalLinesCount = 12;

  return (
    <svg className={styles.background}>
      {Array.from({ length: horizontalLinesCount }).map((_, index) => (
        <line
          key={index}
          x1={0}
          y1={(index * heightMinusOne) / (horizontalLinesCount - 1) + 0.5}
          x2={width - 0.5 - pointSize}
          y2={(index * heightMinusOne) / (horizontalLinesCount - 1) + 0.5}
          stroke={rgba(theme.foreground, backgroundGuideAlpha)}
          strokeWidth={1}
        />
      ))}

      <line
        x1={width - pointSize}
        y1={0}
        x2={width - pointSize}
        y2={height}
        stroke={strokeStyle}
        strokeWidth={1}
        strokeOpacity={0.5}
      />
    </svg>
  );
};
